import React from "react";

import styles from "./FollowUpCard.module.css"
import {EventType} from "../../../api/generated";
import classnames from "classnames";
import {getFollowUpTitle} from "../../../utils/enumValueTitleUtil";

interface FollowUpCardProps {
    eventType: EventType
}

export const FollowUpCard: React.FC<FollowUpCardProps> = ({
                                                              eventType
                                                          }) => {

    const getEventCustomStyle = (): string => {
        switch (eventType) {
            case EventType.RequestedCallback:
                return styles.callbackRequest
            case EventType.RequestedTestDrive:
                return styles.testDrive
            case EventType.RequestedServiceCallback:
                return styles.serviceCallback
            case EventType.BookedCallBack:
                return styles.callback
            case EventType.BookedServiceCallBack:
                return styles.serviceCallback
            case EventType.RequestedEmailFollowUp:
            case EventType.BookedEmailFollowUp:
                return styles.emailFollowUp
            case EventType.BookedTestDrive:
                return styles.testDrive
            default:
                throw new Error(`Unsupported chatEvent: ${eventType}`)
        }
    }

    const getIcon = (): string => {
        switch (eventType) {
            case EventType.RequestedCallback:
            case EventType.BookedCallBack:
                return "/mobilePhoneIcon.svg"
            case EventType.RequestedServiceCallback:
            case EventType.BookedServiceCallBack:
                return "/serviceIcon.png"
            case EventType.RequestedEmailFollowUp:
            case EventType.BookedEmailFollowUp:
                return "/emailIcon.svg"
            case EventType.RequestedTestDrive:
            case EventType.BookedTestDrive:
                return "/testDriveIcon.svg"
            default:
                throw new Error(`Unsupported chatEvent: ${eventType}`)
        }
    }

    const title = getFollowUpTitle(eventType)

    return <div className={classnames(styles.wrapper, getEventCustomStyle())}>
        <img
            className={styles.icon}
            alt={title}
            src={getIcon()}
        />
        <span className={styles.title}>{title}</span>
    </div>
}
